module.exports = __webpack_public_path__ + "static/media/record.62d6de84.svg";